module.exports = __webpack_public_path__ + "img/1928-44-NAACP-cropped.4c148171.jpg";